import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Tab,
  Tabs,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import OrderedItems from './OrderedItems';
import OrderPaymentShippingData from './OrderPaymentShippingData';
import OrderShippingData from './OrderShippingData';
import OrderAddressInformation from './OrderAddressInformation';
import OrderAccountInfo from './OrderAccountInfo';
import OrderDiscountsCoupons from './OrderDiscountsCoupons';
import OrderNotes from './OrderNotes';
import OrderShipment from './OrderShipment';
import OrderIntegrations from './OrderIntegrations';
import OrderActions from './OrderActions';


const useStyles = makeStyles({
  tabsContainer: {
    '& .MuiTab-root': {
      fontSize: '11px',
    },
    '& .MuiTabs-root': {
      borderBottom: '1px solid #103A99',
      padding: '0 1%',
      '& .MuiTab-root': {
        width: 'calc(100%/7 - 2px)',
      }
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .tab': {
      padding: '20px 9%'
    },
    '& .MuiTab-textColorPrimary': {
      color: '#434343',
      backgroundColor: '#f0f8ff',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      margin: '5px 1px -1px',
      border: '1px solid #D0E9FF'
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      background: '#103A99',
      color: '#fff'
    },
    '& .MuiTableCell-body.MuiTableCell-root': {
      color: '#434343'
    },
  }
});

const orderDataTabs = [
  'Items Ordered',
  'Payment & Shipping Method',
  'Shipments',
  'Address Information',
  'Order & Account Information',
  'Discounts & Coupons',
  'Notes'
];

const Order = ({order}) => {
  const { nextech_id, modmed_id } = order.extension_attributes;
  const classes = useStyles();
  const [tabValue, setTabValue] = useState('0');
  const [openShipment, setOpenShipment] = useState(false);

  const isNextechDisabled = nextech_id === 'nextech_disabled' || nextech_id === 'synced_before_cron';
  const isModmedDisabled = modmed_id === 'modmed_disabled' || modmed_id === 'synced_before_cron';
  const isIntegrationsEnabled = !(isModmedDisabled && isNextechDisabled);

  const {
    orderItemsDetails
  } = useSelector((state: IReduxState) => state.store_orders);
  return (
    <>
      {openShipment ?
        <OrderShipment
          order={order}
          orderItemsDetails={orderItemsDetails[order.entity_id]}
          setOpenShipment={setOpenShipment}
        />
        :
        <div className={classes.tabsContainer}>
          <Tabs
            value={tabValue}
            onChange={(event, newValue) => setTabValue(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"

          >
            {orderDataTabs.map((tab, index) => (
              <Tab
                key={`tab-${index}`}
                className="capitalize font-medium font-bold flex items-center px-4"
                label={tab}
                value={`${index}`}
              />
            ))}
            {isIntegrationsEnabled &&
              <Tab
                className="capitalize font-medium font-bold flex items-center px-4"
                label="Integrations"
                value="7"
              />
            }
          </Tabs>
          {tabValue === '0' && <OrderedItems order={order} />}
          {tabValue === '1' && <OrderPaymentShippingData order={order} />}
          {tabValue === '2' && <OrderShippingData order={order} />}
          {tabValue === '3' && <OrderAddressInformation order={order} />}
          {tabValue === '4' && <OrderAccountInfo order={order} />}
          {tabValue === '5' && <OrderDiscountsCoupons order={order} />}
          {tabValue === '6' && <OrderNotes order={order} />}
          {tabValue === '7' && <OrderIntegrations order={order} />}
          <OrderActions
            order={order}
            setOpenShipment={setOpenShipment}
          />
        </div>
      }
    </>
  );
};

export default Order;
